import React, { useCallback, useEffect, useState, memo, useMemo } from "react"
import Link from "./link"
import { GatsbyImage } from "gatsby-plugin-image"
import Spacer from "./spacer"
import { useInView } from "react-intersection-observer"
import useMobile from "../hooks/useMobile"

const NextItem = memo(({ items, state,link = '/work' }) => {

  const [currentIndex, setCurrentIndex] = useState(0)
  const [timer, setTimer] = useState(null)
  const [willChange, setWillChange] = useState(false)

  const intervalAmount = useMemo(() => {
    if (state === 'notMobile') {
      return 250
    }
    return 500
  }, [state])

  const createInterval = useCallback(() => {
    if (timer) {
      return
    }
    const interval = setInterval(() => {
      setCurrentIndex((index) => {
        if (index >= items.length - 1) {
          return 0
        }
        return index + 1
      })
    }, intervalAmount);
    return interval
  }, [timer, items.length, intervalAmount])

  const destoryTimer = useCallback(() => {
    clearInterval(timer);
    setTimer(null)
  }, [timer])

  const creatTimer = useCallback(() => {
    setTimer(createInterval())
  }, [setTimer, createInterval])

  useEffect(() => {
    return () => clearInterval(timer);
  }, [timer])

  useEffect(() => {
    if (state === 'inView') {
      creatTimer()
    } else if (state === 'outOfView') {
      destoryTimer()
    }

  }, [state]) // eslint-disable-line 


  return (
    <div role='presentation' className='all--projects p10' onMouseLeave={() => setWillChange(false)} onMouseEnter={() => setWillChange(true)}>
      <Spacer />
      <div className='bt1 pb15' />
      <Link to={link} className='link flex align-center'>
        <div className="max-150 w-100">
          <div className="ratio-1-2 pos-rel overflow-hidden">
            <Items items={items} willChange={willChange} currentIndex={currentIndex} />
          </div>
        </div>
        <div className='w-50 mla flex h4 uppercase text-light'>
          <p className='ul-link m0 mr15' role='presentation' onMouseOver={creatTimer} onFocus={creatTimer} onMouseOut={destoryTimer} onBlur={destoryTimer}>View All</p>
          <div className=" mra">
            <p className='m0 '>[{items.length + 1}]</p>
          </div>
        </div>
      </Link>
    </div>
  )
})


const InviewWrapper = ({ ...props }) => {
  const isMobile = useMobile()
  const { ref, inView } = useInView({});
  const [elInView, setElInView] = useState()

  useEffect(() => {
    if (isMobile) {
      if (inView) {
        return setElInView('inView')
      } else {
        return setElInView('outOfView')
      }
    }
    return setElInView('notMobile')
  }, [inView, isMobile])

  return (
    <div ref={ref}>
      <NextItem state={elInView} {...props} />
    </div>
  )
}


const Items = memo(({ items, willChange, currentIndex }) => {
  return items.map((item, index) => {
    if (item.node.featuredImage?.gatsbyImageData) {
      return (
        <Item loading='eager' key={index} willChange={willChange} item={item} current={(index === currentIndex)} />
      )
    } else {
      return null
    }
  }
  )
})

const Item = memo(({ current, willChange, item }) => {
  return (
    <div className={'project--thumbnail h-100  ' + (willChange ? 'will-change ' : ' ') + (current ? ' active' : '')}>
      <GatsbyImage className={'bg-image '} image={item.node.featuredImage.gatsbyImageData} alt="Project Thumbnail" />
    </div>
  )
})




export default memo(InviewWrapper)
